import { last } from 'lodash';
import debug from 'debug';
const log = debug('itp:runtime:document-title');
export class DocumentTitle {
    defaultTitle;
    postfix;
    history;
    constructor(defaultTitle, postfix = '') {
        this.defaultTitle = defaultTitle;
        this.postfix = postfix;
        this.history = [];
        document.title = this.title;
    }
    get title() {
        if (this.history.length) {
            return `${last(this.history)}${this.postfix}`;
        }
        return `${this.defaultTitle}${this.postfix}`;
    }
    set(title) {
        if (!this.history.length ||
            (this.history.length && last(this.history) != title)) {
            this.history.push(title);
            log('set [%s]', this.title);
            document.title = this.title;
        }
    }
    reset() {
        if (this.history.length) {
            this.history = this.history.slice(0, -1);
            log('reset [%s]', this.title);
            document.title = this.title;
        }
    }
}
//# sourceMappingURL=document-title.js.map